
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertheaderAggregatedLargeIec as ObiAlertheaderAggregatedLargeIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alertheader-aggregated-large-iec.js';
 
 
 

 
 export const ObiAlertheaderAggregatedLargeIec = createComponent({
   react: React,
   tagName: 'obi-alertheader-aggregated-large-iec',
   elementClass: ObiAlertheaderAggregatedLargeIecElement,
   events: {
     
   }
  });
 
 